export const environment = {
  production: false,
  apiUrl: 'https://rep-dev.avikeo.com/api'
};
